import './titleBanner.scss';

import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

interface ITitleBannerProps {
    bgImage?: string;
    imageData?: any;
    title: string;
    className?: string;
}

export default function TitleBanner(props: ITitleBannerProps) {
    return (
        <div className={`title-banner ${props.className}`}>
            {props.bgImage && <img src={props.bgImage} alt='' />}
            {props.imageData && <GatsbyImage image={props.imageData} alt='' />}
            <div className='blur'></div>
            <div className='title'>
                <h1>{props.title}</h1>
            </div>
        </div>
    );
}
